import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import { MeetingTypeManager } from './MeetingTypeManager';
import { BookingHoursEditor } from './BookingHoursEditor';

/**
 * Einstellungsmaske „Termine" (Terminbuchung): Pflege der Terminarten und der
 * buchbaren Zeitfenster. Zwei Tabs.
 */
export const MeetingBookingSettings: React.FC = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_event, value: number) => setTab(value)}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label='Terminarten' />
        <Tab label='Buchbare Zeiten' />
      </Tabs>

      {tab === 0 && <MeetingTypeManager />}
      {tab === 1 && <BookingHoursEditor />}
    </Box>
  );
};

export default MeetingBookingSettings;
